export interface ComicChapter {
  id: number;
  title: string;
  chapterNumber: number;
  updateDate: string;
}

export interface Comic {
  id: number;
  title: string;
  author: string;
  coverImage: string;
  description: string;
  shortDescription: string;
  categories: string[];
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  chapters: ComicChapter[];
  updateDate: string;
  publishYear: number;
  tags: string[];
}

export const categories = [
  { id: 'all', name: '全部', icon: 'ri-apps-line' },
  { id: 'romance', name: '恋爱', icon: 'ri-heart-line' },
  { id: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { id: 'action', name: '动作', icon: 'ri-sword-line' },
  { id: 'suspense', name: '悬疑', icon: 'ri-search-eye-line' },
  { id: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line' },
  { id: 'drama', name: '剧情', icon: 'ri-film-line' },
  { id: 'horror', name: '惊悚', icon: 'ri-ghost-line' },
  { id: 'school', name: '校园', icon: 'ri-book-open-line' },
  { id: 'workplace', name: '职场', icon: 'ri-briefcase-line' },
];

export const comics: Comic[] = [
  {
    id: 1,
    title: '金牌秘书的秘密',
    author: '金秀雅',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20cover%20art%20featuring%20a%20stylish%20female%20office%20worker%20in%20elegant%20attire%20looking%20confident%2C%20soft%20romance%20manga%20style%20illustration%20with%20warm%20peach%20and%20cream%20tones%2C%20clean%20simple%20background%20with%20subtle%20gradient%2C%20high%20quality%20digital%20art&width=400&height=560&seq=comic-01&orientation=portrait',
    description: '职场精英金秀妍因为一次意外成为了集团总裁的贴身秘书。表面上是完美无缺的职场女性，实际上却隐藏着一个不为人知的秘密——她是竞争对手公司派来的商业间谍。在日复一日的相处中，秀妍发现自己逐渐对这位冷酷却温柔的上司产生了真挚的感情，而她的真实身份也即将被揭穿⋯⋯',
    shortDescription: '职场精英女秘书与霸道总裁之间隐瞒身份的危险恋情。',
    categories: ['romance', 'workplace', 'drama'],
    status: '连载中',
    rating: 4.8,
    views: 12500000,
    chapters: Array.from({ length: 89 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话${i === 0 ? ' 命运的相遇' : i === 88 ? ' 最后的抉择' : ''}`,
      chapterNumber: i + 1,
      updateDate: `2026-0${Math.floor(i / 30) + 1}-${String((i % 30) + 1).padStart(2, '0')}`,
    })),
    updateDate: '2026-08-04',
    publishYear: 2024,
    tags: ['霸道总裁', '职场恋情', '身份秘密', '女强人'],
  },
  {
    id: 2,
    title: '剑与魔法之域',
    author: '李贤宇',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20fantasy%20Korean%20manhwa%20cover%20featuring%20a%20powerful%20male%20warrior%20with%20a%20glowing%20sword%20in%20epic%20armor%2C%20magical%20runes%20floating%20around%2C%20dark%20fantasy%20illustration%20style%20with%20gold%20and%20crimson%20accents%2C%20dramatic%20lighting%2C%20high%20quality%20digital%20art&width=400&height=560&seq=comic-02&orientation=portrait',
    description: '平凡的高中生韩宇辰在一次意外中穿越到了剑与魔法的异世界。在这个充满危险与机遇的世界里，他发现自己拥有前所未有的天赋——能够同时掌握剑术与魔法。为了找到回家的路，他必须成为这个世界最强大的冒险者。',
    shortDescription: '高中生穿越异世界，剑术与魔法双修的奇幻冒险之旅。',
    categories: ['fantasy', 'action'],
    status: '连载中',
    rating: 4.7,
    views: 9800000,
    chapters: Array.from({ length: 72 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateDate: `2026-0${Math.floor(i / 24) + 1}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    updateDate: '2026-08-03',
    publishYear: 2024,
    tags: ['异世界', '剑与魔法', '冒险', '成长'],
  },
  {
    id: 3,
    title: '甜蜜的谎言',
    author: '崔恩智',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20sweet%20romance%20Korean%20manhwa%20cover%20with%20a%20young%20couple%20sharing%20a%20gentle%20moment%20under%20cherry%20blossoms%2C%20soft%20pastel%20pink%20and%20mint%20color%20palette%2C%20romantic%20shojo%20style%20illustration%2C%20clean%20background%2C%20high%20quality%20digital%20art&width=400&height=560&seq=comic-03&orientation=portrait',
    description: '为偿还家庭债务，林小希被迫与财阀继承人签订了契约恋爱协议。原本只是一场各取所需的交易，却在朝夕相处间酝酿出真挚的情感。当契约到期的那一天，他们能否放下各自的伪装，诚实地面对彼此的心？',
    shortDescription: '契约恋爱从谎言开始，却以真心收场的甜蜜故事。',
    categories: ['romance', 'drama'],
    status: '已完结',
    rating: 4.9,
    views: 15800000,
    chapters: Array.from({ length: 64 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateDate: `2026-0${Math.floor(i / 20) + 1}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    updateDate: '2026-07-15',
    publishYear: 2023,
    tags: ['契约恋爱', '财阀', '治愈', '甜宠'],
  },
  {
    id: 4,
    title: '暗夜追踪者',
    author: '朴正勋',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20noir%20suspense%20Korean%20manhwa%20cover%20with%20a%20detective%20in%20trench%20coat%20standing%20in%20rainy%20urban%20alleyway%2C%20moody%20dark%20atmosphere%2C%20neon%20signs%20reflecting%20on%20wet%20pavement%2C%20thriller%20style%20illustration%2C%20high%20quality%20digital%20art&width=400&height=560&seq=comic-04&orientation=portrait',
    description: '前刑警姜泰浩因为一起悬案被警队开除，从此成为一名私家侦探。当一系列离奇的失踪案件重新浮出水面，他发现这些案件之间存在着诡异的联系，而真相远比想象中更加黑暗。每解开一个谜题，就有新的谜团出现。',
    shortDescription: '前刑警追查连环失踪案，层层揭开隐藏在都市阴影下的惊人真相。',
    categories: ['suspense', 'action', 'drama'],
    status: '连载中',
    rating: 4.6,
    views: 7200000,
    chapters: Array.from({ length: 56 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateDate: `2026-0${Math.floor(i / 18) + 1}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    updateDate: '2026-08-02',
    publishYear: 2025,
    tags: ['悬疑', '推理', '都市', '犯罪'],
  },
  {
    id: 5,
    title: '废柴逆袭日记',
    author: '尹智勋',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20comedy%20Korean%20manhwa%20cover%20with%20a%20goofy%20high%20school%20boy%20making%20a%20funny%20face%2C%20bright%20colorful%20cartoon%20illustration%20style%2C%20comic%20effect%20lines%2C%20yellow%20and%20orange%20vibrant%20colors%2C%20clean%20simple%20background%2C%20high%20quality%20digital%20art&width=400&height=560&seq=comic-05&orientation=portrait',
    description: '全校倒数第一的李大河某天醒来发现自己获得了"逆袭系统"——只要完成系统发布的任务，就能获得各种神奇的能力。但是这个系统的任务总是让人哭笑不得：今天让他在食堂当着全校学生跳舞，明天让他给班主任写情书⋯⋯',
    shortDescription: '全校吊车尾获得逆袭系统，搞笑任务层出不穷的校园喜剧。',
    categories: ['comedy', 'school'],
    status: '连载中',
    rating: 4.5,
    views: 8400000,
    chapters: Array.from({ length: 48 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateDate: `2026-0${Math.floor(i / 16) + 1}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    updateDate: '2026-08-04',
    publishYear: 2025,
    tags: ['搞笑', '校园', '系统', '逆袭'],
  },
  {
    id: 6,
    title: '永生者的孤独',
    author: '郑恩彩',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dramatic%20Korean%20manhwa%20cover%20featuring%20an%20immortal%20being%20with%20a%20melancholic%20expression%2C%20ancient%20and%20modern%20elements%20blended%2C%20ethereal%20atmosphere%20with%20soft%20silver%20and%20deep%20indigo%20tones%2C%20time%20symbolism%2C%20high%20quality%20digital%20art&width=400&height=560&seq=comic-06&orientation=portrait',
    description: '活了三百年的金道允早已厌倦了永生。他见证了爱人的离去、朋友的消逝，以及时代的变迁。就在他决定结束这无尽生命的时候，一个能够看见他过去记忆的女孩出现了，让他重新思考生命的意义。',
    shortDescription: '活了三百年的人与能看见他记忆的少女之间关于生命的深刻故事。',
    categories: ['drama', 'fantasy'],
    status: '已完结',
    rating: 4.9,
    views: 6800000,
    chapters: Array.from({ length: 42 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateDate: `2026-0${Math.floor(i / 14) + 1}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    updateDate: '2026-06-20',
    publishYear: 2024,
    tags: ['永生', '生命意义', '治愈', '奇幻'],
  },
  {
    id: 7,
    title: '恶灵契约',
    author: '韩智敏',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20horror%20Korean%20manhwa%20cover%20with%20a%20terrifying%20ghostly%20figure%20emerging%20from%20shadows%2C%20dark%20occult%20themes%2C%20cold%20blue%20and%20deep%20black%20color%20scheme%2C%20creepy%20atmosphere%2C%20gothic%20horror%20illustration%20style%2C%20high%20quality%20digital%20art&width=400&height=560&seq=comic-07&orientation=portrait',
    description: '搬进便宜公寓的大学生朴志浩发现自己的房间每晚都会传来奇怪的声音。好奇心驱使下，他发现房间的墙壁里封印着一个古老的恶灵。当他意外解开了封印，一场与恶灵之间的致命游戏就此展开。',
    shortDescription: '大学生意外解开公寓封印，与恶灵进行致命游戏。',
    categories: ['horror', 'suspense', 'drama'],
    status: '连载中',
    rating: 4.4,
    views: 5100000,
    chapters: Array.from({ length: 38 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateDate: `2026-0${Math.floor(i / 12) + 1}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    updateDate: '2026-08-01',
    publishYear: 2025,
    tags: ['恐怖', '恶灵', '悬疑', '都市传说'],
  },
  {
    id: 8,
    title: '那年夏天的我们',
    author: '宋恩书',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20heartwarming%20school%20romance%20Korean%20manhwa%20cover%20with%20two%20teenagers%20walking%20along%20a%20sunset%20beach%2C%20nostalgic%20summer%20vibes%2C%20warm%20orange%20and%20golden%20tones%2C%20youth%20drama%20style%20illustration%2C%20clean%20background%2C%20high%20quality%20digital%20art&width=400&height=560&seq=comic-08&orientation=portrait',
    description: '高二那年夏天，转学生沈夏琳遇到了坐在窗边的少年林灿宇。一个喜欢画画的安静女孩，一个热爱音乐的阳光少年，在青春最美好的季节里，他们一起经历了欢笑、泪水、梦想和成长。这是一个关于青春、初恋与成长的故事。',
    shortDescription: '一个关于青春、初恋与成长的温暖校园故事。',
    categories: ['romance', 'school', 'drama'],
    status: '已完结',
    rating: 4.8,
    views: 11200000,
    chapters: Array.from({ length: 52 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateDate: `2026-0${Math.floor(i / 17) + 1}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    updateDate: '2026-05-30',
    publishYear: 2023,
    tags: ['青春', '校园', '初恋', '成长'],
  },
  {
    id: 9,
    title: '职场生存法则',
    author: '郑秀晶',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20workplace%20drama%20Korean%20manhwa%20cover%20featuring%20multiple%20office%20workers%20in%20business%20attire%20standing%20in%20a%20modern%20office%2C%20corporate%20life%20theme%2C%20professional%20and%20clean%20illustration%20style%2C%20neutral%20gray%20and%20navy%20tones%2C%20high%20quality%20digital%20art&width=400&height=560&seq=comic-09&orientation=portrait',
    description: '大企业新人赵敏俊怀着满腔热情踏入职场，却发现自己置身于一个充满办公室政治、明争暗斗的世界。幸运的是，他遇到了一位愿意指导他的前辈。在职场导师的帮助下，他逐渐领悟到职场生存的真正法则。',
    shortDescription: '职场新人面对办公室政治，在前辈指导下快速成长的故事。',
    categories: ['workplace', 'drama', 'comedy'],
    status: '连载中',
    rating: 4.6,
    views: 5900000,
    chapters: Array.from({ length: 44 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateDate: `2026-0${Math.floor(i / 14) + 1}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    updateDate: '2026-08-03',
    publishYear: 2025,
    tags: ['职场', '办公室政治', '成长', '导师'],
  },
  {
    id: 10,
    title: '魔王的继承人',
    author: '崔成浩',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20fantasy%20Korean%20manhwa%20cover%20with%20a%20young%20hero%20facing%20a%20massive%20demon%20lord%2C%20epic%20battle%20scene%2C%20dark%20and%20fiery%20background%2C%20action%20manga%20style%20with%20dramatic%20effects%2C%20high%20quality%20digital%20art&width=400&height=560&seq=comic-10&orientation=portrait',
    description: '魔王在被勇者击败前，将全部力量封印在一个人类的婴儿身上。十七年后，这个名叫安在赫的少年体内的魔王之力开始觉醒。他必须在光明与黑暗之间做出选择——成为世界的毁灭者，还是救世主？',
    shortDescription: '继承了魔王之力的少年在光明与黑暗之间的命运抉择。',
    categories: ['fantasy', 'action', 'drama'],
    status: '连载中',
    rating: 4.7,
    views: 10300000,
    chapters: Array.from({ length: 66 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateDate: `2026-0${Math.floor(i / 22) + 1}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    updateDate: '2026-08-04',
    publishYear: 2024,
    tags: ['魔王', '力量觉醒', '命运', '战斗'],
  },
  {
    id: 11,
    title: '深夜便利店的她',
    author: '李多海',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20slice%20of%20life%20Korean%20manhwa%20cover%20with%20a%20girl%20working%20at%20a%20convenience%20store%20at%20night%2C%20warm%20neon%20lighting%2C%20cozy%20urban%20night%20atmosphere%2C%20romantic%20comedy%20style%20with%20soft%20colors%2C%20high%20quality%20digital%20art&width=400&height=560&seq=comic-11&orientation=portrait',
    description: '夜班便利店员姜书妍每天在深夜迎来送往着各式各样的顾客。一个总是凌晨三点来买咖啡的沉默男人引起了她的好奇。他们的故事，就在这间小小的便利店里悄然开始。',
    shortDescription: '深夜便利店里，店员与神秘顾客之间温暖治愈的都市故事。',
    categories: ['romance', 'comedy', 'drama'],
    status: '已完结',
    rating: 4.7,
    views: 7600000,
    chapters: Array.from({ length: 36 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateDate: `2026-0${Math.floor(i / 12) + 1}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    updateDate: '2026-07-01',
    publishYear: 2024,
    tags: ['治愈', '便利店', '都市', '温情'],
  },
  {
    id: 12,
    title: '猎魔人传说',
    author: '张泰民',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20supernatural%20action%20Korean%20manhwa%20cover%20with%20a%20demon%20hunter%20wielding%20dual%20blades%2C%20surrounded%20by%20supernatural%20energies%2C%20urban%20fantasy%20setting%2C%20dynamic%20action%20pose%2C%20red%20and%20black%20color%20scheme%2C%20high%20quality%20digital%20art&width=400&height=560&seq=comic-12&orientation=portrait',
    description: '在这个被恶魔悄然入侵的现代世界里，有一群不为人知的猎魔人守护着人类。主角韩石镇继承了父亲的猎魔人身份，在都市的暗处与各种超自然威胁战斗。但他逐渐发现，最大的威胁可能来自人类自身。',
    shortDescription: '现代都市中的猎魔人对抗恶魔与人性黑暗的战斗故事。',
    categories: ['action', 'fantasy', 'horror'],
    status: '连载中',
    rating: 4.5,
    views: 6500000,
    chapters: Array.from({ length: 54 }, (_, i) => ({
      id: i + 1,
      title: `第${i + 1}话`,
      chapterNumber: i + 1,
      updateDate: `2026-0${Math.floor(i / 18) + 1}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    updateDate: '2026-08-02',
    publishYear: 2025,
    tags: ['猎魔人', '都市奇幻', '战斗', '超自然'],
  },
];